import { IosArrowDown, IosArrowUp } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import { useState } from 'react';

import { ImageWithFallback } from '@/components/image-with-fallback';
import { TextLink } from '@/components/text-link';
import { joinSgcmMedia } from '@/utils/url/join/public';

import { businessStatusConfigMap } from './configs';
import { COLLAPSIBLE_ARRAOW_ICON_SIZE, ICON_SIZE_IN_PIXEL } from './constants';
import { OpeningHourList } from './opening-hour-list';
import styles from './styles.module.scss';
import type { Component } from './types';
import {
  getCurrentFullBusinessInfo,
  getGroupedBusinessHours,
  getTodayBusinessHours,
} from './utils';

export const AdInfoItem: Component = ({
  adInfo,
}) => {
  const {
    name,
    hotlines,
    address,
    openingHours,
  } = adInfo;
  const [collapsibleStatus, setCollapsibleStatus] = useState(false);
  const lastPhoneIndex = hotlines.length - 1;
  const hasCompleteOpeningHours = Array.isArray(openingHours);
  const CollapsibleArrowIcon = collapsibleStatus ? IosArrowUp : IosArrowDown;

  const todayBusinessHours = hasCompleteOpeningHours
    && getTodayBusinessHours(openingHours);

  const currentFullBusinessInfo = todayBusinessHours
    && getCurrentFullBusinessInfo(todayBusinessHours);

  const groupedBusinessHours = hasCompleteOpeningHours
    && getGroupedBusinessHours(openingHours);

  const formatPhone = (phone: string) => `${phone.slice(0, 4)} ${phone.slice(4)}`;

  return (
    <div className={styles.containerRoot}>
      <div className={styles.containerContent}>
        <div className={styles.textAdName}>
          {name}
        </div>
        <div className={cx(
          styles.containerRow,
          styles.containerLocation,
        )}>
          <ImageWithFallback
            alt="pricelist icon"
            height={ICON_SIZE_IN_PIXEL}
            src={`${joinSgcmMedia('/public/new-cars/icon/outlinedLocation.svg')}`}
            title="pricelist"
            width={ICON_SIZE_IN_PIXEL}
            priority />
          <div className={styles.textItemContent}>
            {address.location}
            {' ('}
            <a
              className={styles.textLocation}
              href={`https://www.google.com/maps/search/Singapore+${address.location}/`}
              rel="noreferrer"
              target="_blank">
              {address.postalCode}
            </a>
            {') '}
          </div>
        </div>
        <div className={styles.containerRow}>
          <ImageWithFallback
            alt="phone icon"
            height={ICON_SIZE_IN_PIXEL}
            src={`${joinSgcmMedia('/public/new-cars/icon/outlinePhone.svg')}`}
            title="hotline"
            width={ICON_SIZE_IN_PIXEL}
            priority />
          <div className={cx(
            styles.textPhones,
            styles.textItemContent,
          )}>
            {hotlines.map((phone, index) => (
              <div key={phone}>
                <TextLink
                  href={`tel:${phone}`}
                  text={formatPhone(phone)} />
                { index < lastPhoneIndex
                && <span className={styles.textSeperator}>/</span>}
              </div>
            ))}
          </div>
        </div>
        {openingHours && hasCompleteOpeningHours && todayBusinessHours
        && (
          <OpeningHourList
            collapseStatus={collapsibleStatus}
            onClick={setCollapsibleStatus}>
            <div className={styles.containerRow}>
              <ImageWithFallback
                alt="business hour icon"
                height={ICON_SIZE_IN_PIXEL}
                src={`${joinSgcmMedia('/public/new-cars/icon/outlinedOpeningHour.svg')}`}
                title="hotline"
                width={ICON_SIZE_IN_PIXEL}
                priority />
              {currentFullBusinessInfo
              && (
                <div
                  className={cx(
                    styles.containerBusinessStatus,
                  )}>
                  <div className={cx(
                    styles.textCurrentBusinessStatus,
                    styles[businessStatusConfigMap[currentFullBusinessInfo.businessStatus].className], // @suppress longLineCheck
                  )}>
                    {
                      businessStatusConfigMap[currentFullBusinessInfo.businessStatus].text // @suppress longLineCheck
                    }
                    <span className={styles.dividerBullet}>
                      •
                    </span>
                  </div>
                  <div className={styles.textBusinessInfo}>
                    {currentFullBusinessInfo.nextBusinessPeriod}
                    <CollapsibleArrowIcon
                      className={styles.iconGrayArrow}
                      size={COLLAPSIBLE_ARRAOW_ICON_SIZE} />
                  </div>
                </div>
              )}
            </div>
            <div className={styles.openHoursContainer}>
              {groupedBusinessHours && groupedBusinessHours.map(hours => (
                <div
                  key={hours.period}
                  className={styles.textOpeningHour}>
                  {hours.startAt}
                  {' '}
                  -
                  {' '}
                  {hours.endAt}
                  {' '}
                  {hours.period && (
                    <span>
                      (
                      {hours.period}
                      )
                    </span>
                  )}
                </div>
              ))}
            </div>
          </OpeningHourList>
        )}
        {openingHours && !hasCompleteOpeningHours
        && (
          <div className={styles.textBusinessInfo}>
            <ImageWithFallback
              alt="phone icon"
              height={ICON_SIZE_IN_PIXEL}
              src={`${joinSgcmMedia('/public/new-cars/icon/outlinedOpeningHour.svg')}`}
              title="hotline"
              width={ICON_SIZE_IN_PIXEL}
              priority />
            {openingHours}
          </div>
        )}
      </div>
    </div>
  );
};
